<div class="flex items-center" *ngIf="showClientTypeOption">
	<h5 class="mr-2">Client type</h5>
	<app-button
		class="m-2"
		[noText]="true"
		[btn]="clientType === clientTypes.PERSON ? 'primary' : 'tertiary'"
		[icon]="ICON.PERSON"
		(click)="setClientType(clientTypes.PERSON)"
		*ngIf="showPersonOption"
		matTooltip="Person client"
		[testHook]="testHooks.SetPersonClientTypeButton"
	></app-button>
	<app-button
		class="m-2"
		[noText]="true"
		[btn]="clientType === clientTypes.CORPORATION ? 'primary' : 'tertiary'"
		[icon]="ICON.CORPORATION"
		(click)="setClientType(clientTypes.CORPORATION)"
		*ngIf="showCorporationOption"
		matTooltip="Corporation client"
		[testHook]="testHooks.SetCorporationClientTypeButton"
	></app-button>
	<app-button
		class="m-2"
		[noText]="true"
		[btn]="clientType === clientTypes.BUILDER ? 'primary' : 'tertiary'"
		[icon]="ICON.BUILDER"
		(click)="setClientType(clientTypes.BUILDER)"
		*ngIf="showBuilderOption"
		matTooltip="Builder client"
		[testHook]="testHooks.SetBuilderClientTypeButton"
	></app-button>
</div>

<app-aps-create-person-client-side-form
	*ngIf="clientType === clientTypes.PERSON"
	[clientName]="clientName"
	[firstName]="firstName"
	[middleName]="middleName"
	[lastName]="lastName"
	[phone]="phone"
	[(primary)]="primaryContact"
	[workPhone]="workPhone"
	[showPrimaryClientOption]="showPrimaryClientOption"
	[showIDsOption]="showIDsOption"
	[showRepresentationOption]="showRepresentationOption"
	[matterClientType]="matterClientType"
	(onCreate)="_onCreate($event)"
	(onCancel)="_onCancel($event)"
	[minify]="minify"
>
</app-aps-create-person-client-side-form>

<app-aps-create-business-client-side-form
	*ngIf="clientType !== clientTypes.PERSON"
	[clientName]="clientName"
	[type]="clientType"
	(onCreate)="_onCreate($event)"
	(onCancel)="_onCancel($event)"
	[showPrimaryClientOption]="showPrimaryClientOption"
	[enableSigningOfficers]="enableSigningOfficers"
	[(primary)]="primaryContact"
	[minify]="minify"
>
</app-aps-create-business-client-side-form>
